<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
		<g transform="translate(-1659 -434)"><path d="M17,4H5.75A3.745,3.745,0,0,0,2.019,7.75L2,30.25A3.761,3.761,0,0,0,5.75,34h30a3.761,3.761,0,0,0,3.75-3.75V11.5a3.761,3.761,0,0,0-3.75-3.75h-15Z" transform="translate(1660.75 437.5)"/><path class="a" d="M0,0H45V45H0Z" transform="translate(1659 434)"/></g>
	</svg>
</template>

<script>
export default {
	name: 'b-folder',
	components: {},
	computed: {},
	props: {},
};
</script>

<style scoped lang="scss">
  path.a {
    fill: none;
  }
</style>

<docs>
    IconFolder

    ```js
    <b-folder />
    ```
</docs>
